export default "__VITE_ASSET__DeacBR9E__"